import { ListItem } from '../components/Modal/AddNewAppModal/LocationsList';

const mocksLocationData: ListItem[] = [
  { id: 'LQ6KR0V6VWP3C1', title: 'Mocked location 1' },
  { id: 'LQ6KR0V6VWP3C2', title: 'Mocked location 2' },
  { id: 'LQ6KR0V6VWP3C3', title: 'Mocked location 3' },
  { id: 'LQ6KR0V6VWP3C4', title: 'Mocked location 4' },
];

export { mocksLocationData };